export const LANDING_LINK_PREFETCH = true;

export const LANDING_ROUTES = {
  accountDeletion: '/account-deletion',
  firmRegistration: '/firm-registration',
  home: '/',
  login: '/login',
  organizations: '/organizations',
  privacyPolicy: '/privacy-policy',
  termsAndConditions: '/terms-and-conditions',
  userProfile: '/user-profile',
  signUp: '/sign-up',
  organizationDetail: (firmId: string) =>
    `/organizations/${encodeURIComponent(firmId)}`
} as const;
